import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';

type UseDeleteTrackableFilesParams = {
  trackable_list_id: string;
  trackable_item_id: string;
  trackable_file_ids: string[];
};

export function useDeleteTrackableFiles({
  onSuccess,
  onError,
  onSettled,
  ...options
}: UseMutationOptions<void, APIError, UseDeleteTrackableFilesParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ trackable_list_id, trackable_item_id, trackable_file_ids }: UseDeleteTrackableFilesParams) => {
      const searchParams = new URLSearchParams();
      trackable_file_ids.forEach(id => searchParams.append('trackable_file_ids[]', id));
      
      const url = `/apps/${applicationID}/trackables/${trackable_list_id}/items/${trackable_item_id}/files?${searchParams.toString()}`;
      await client.delete(url);
    },
    {
      ...options,
      onSuccess: (...args) => {
        onSuccess?.(...args);
        queryClient.invalidateQueries(['trackable-files']);
      },
      onError,
      onSettled,
    }
  );
}